import { render, staticRenderFns } from "./aldehyd-fehling.vue?vue&type=template&id=7a420fc0&"
import script from "./aldehyd-fehling.vue?vue&type=script&lang=js&"
export * from "./aldehyd-fehling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports